import {Component, OnInit, ViewChild} from '@angular/core';
import {
    AcabimProject,
    AcabimResource,
    AcabimSite,
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableDataSource,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    DatatableComponent,
    FinancialService,
    LocationService,
    PermissionsService,
    TableAction, PaginatedRequest,
} from '@cas-hub/acabim-common-client';
import {LTMSProjectDatatableItem} from '../../_models/ltms.model';
import {LtmsService} from '../../_services/ltms.service';
import {Subscription} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'acabim-admin-manage-ltm-items',
    templateUrl: './manage-ltm-items.component.html',
    styleUrls: ['./manage-ltm-items.component.scss']
})
export class ManageLTMItemsComponent implements OnInit {
    public dataSources: DataTableDataSource<any>[] = [];
    public selectedSite?: AcabimSite;
    public selectedProject: AcabimResource | null = null;

    @ViewChild('ltmItemTable') public itemsTable?: DatatableComponent;

    buildings: AcabimProject[] = [];
    canManage = false;
    finEnabled = false;
    isLoading = true;
    modalTitle = 'Manage Budget and Expenditure';
    projectId = '';
    projectLoading = false;
    projectSub: Subscription =  new Subscription();
    selectedItem: LTMSProjectDatatableItem | null = null;
    showAddModal = false;
    totalRecords = 0;
    columnFilters: ColumnFilter[] = [{
        displayLabel: false,
        columnData: {displayName: 'Status', objectPropertyName: 'status'},
        selectedValue: '8',
        filterOptions: [{label: 'active', value: '8'}, {label: 'in-active', value: '7'}, {
            label: 'cancelled',
            value: '9'
        }]
    }];
    constructor(
        private readonly financialService: FinancialService,
        private readonly locationService: LocationService,
        private readonly ltmsService: LtmsService,
        private readonly permissionsService: PermissionsService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.projectSub = this.locationService.getActiveProject().subscribe(ap => {
            if (ap) {
                this.selectedProject = ap;
                this.financialService.getEnabled().subscribe(finEnabled => {
                    if (finEnabled) {
                        this.finEnabled = true;
                        this.permissionsService.checkUserPermissions('manageAssets').subscribe(permission => {
                            this.canManage = permission;
                            this.isLoading = false;
                            this.dataSources[0] = new LTMItemsDS(true,
                                this.columnFilters,
                                [],
                                (first, length, sortOrder, sortField, filters) => {
                                    return this.ltmsService.getItemsForProject(
                                        this.selectedProject ? this.selectedProject.id : '',
                                        PaginatedRequest.FromDatatableRefresher(first, length, sortOrder, sortField)
                                    ).pipe(
                                            map(inData => {
                                                const final: LTMSProjectDatatableItem[] = [];
                                                inData.forEach(i => {
                                                    const accountName = i.maintenance_type.account ? i.maintenance_type.account?.full_identifier + ' ' +
                                                        i.maintenance_type?.account.name : '';
                                                    const tmp: LTMSProjectDatatableItem = {
                                                        id: i.id,
                                                        maintenance_type_name: i.maintenance_type_name ?? '',
                                                        account_name: accountName,
                                                        term: i.maintenance_type.term ?? '',
                                                        expense_type: i.maintenance_type.expense_type ?? '',
                                                        category: i.maintenance_type.category ?? ''
                                                    };
                                                    final.push(tmp);
                                                });
                                                return {totalRecords: final.length, data: final};
                                            })
                                        );
                                });
                         });
                    } else {
                        this.isLoading = false;
                    }
                });
            } else {
                this.selectedProject = null;
            }
        });

    }

    refreshTable(): void {
        this.itemsTable?.requestImmediateDataRefresh();
    }

    toggleStatus($event: boolean): void {
        this.showAddModal = $event;
        if (!$event && this.itemsTable) {
            this.itemsTable.requestImmediateDataRefresh();
        }
    }

    goToLTMAdmin(): void {
        window.location.href = '/admin/settings/maintenance-type';
    }

    setDetails(value: LTMSProjectDatatableItem) {
        console.dir(value);
        this.selectedItem = value;
    }
}

export class LTMItemsDS extends DataTableLazyLoadDataSource<LTMSProjectDatatableItem> {
    currentYear: number = (new Date()).getFullYear();
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];
    isFilterEnabled: boolean;

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Item Type Name', objectPropertyName: 'maintenance_type_name'},
            {displayName: 'Account', objectPropertyName: 'account_name'},
            {displayName: 'Term', objectPropertyName: 'term', colWidth: '5rem', textAlign: 'center'},
            {displayName: 'Expense type', objectPropertyName: 'expense_type', colWidth: '8rem', textAlign: 'center'},
            {displayName: 'Category', objectPropertyName: 'category', colWidth: '8rem', textAlign: 'center'},
        ];
    onDataExpanded(value: LTMSProjectDatatableItem): void {
    }

    constructor(
        isFilterEnabled: boolean,
        columnFilters: ColumnFilter[],
        actions: TableAction[],
        refresher: DataTableLazyLoadRefresher<LTMSProjectDatatableItem>,
        readonly observableErrorListener?: DataTableObservableErrorListener,
        readonly observableCompleteListener?: DataTableObservableCompletionListener,
        readonly actionListener?: (action: TableAction) => void) {
        super(refresher, observableErrorListener, observableCompleteListener);
        this.isFilterEnabled = isFilterEnabled;
        this.columnFilters = columnFilters;
        this.actions = actions;

        this.config = {
            tableHeading: '',
            showTableHeading: false,
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: 'No long-term maintenance items for the selected project',
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: true,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: true,
            hasActions: false,
            datatableUpdateId: 'LTMItems'
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }
}
